import React from 'react';

import { NwButton } from '@components/Gui/NwButton';
import NwIcon from '@components/Gui/NwIcon';

import {
    ActionItem,
    ActionItemBody,
    ActionItemDescription,
    ActionItemFooter,
    ActionItemIcon,
    ActionItemTitle,
} from './ContactDetailsActions-ui';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const ModelSubtypeActionItem = ({ isInBooking, onMoveToBooking, onMoveToScouting }) => {
    if (isInBooking) {
        return (
            <ActionItem>
                <ActionItemIcon>
                    <NwIcon size="3x" icon={byPrefixAndName.fass['radar']} />
                </ActionItemIcon>
                <ActionItemBody>
                    <ActionItemTitle>Set as Scouting Model</ActionItemTitle>
                    <ActionItemDescription />
                    <ActionItemFooter>
                        <NwButton primary label={'move to scouting'} onClick={onMoveToScouting} />
                    </ActionItemFooter>
                </ActionItemBody>
            </ActionItem>
        );
    }

    return (
        <ActionItem>
            <ActionItemIcon>
                <NwIcon size="3x" icon={byPrefixAndName.fasl['calendar-check']} />
            </ActionItemIcon>
            <ActionItemBody>
                <ActionItemTitle>{`Set as Booking Model`}</ActionItemTitle>
                <ActionItemDescription />
                <ActionItemFooter>
                    <NwButton primary label={'move to booking'} onClick={onMoveToBooking} />
                </ActionItemFooter>
            </ActionItemBody>
        </ActionItem>
    );
};

export default ModelSubtypeActionItem;
